module.exports = __webpack_public_path__ + "static/pink1-9f20f4224244db4443c1fe68d95d8acf.png";